export default __webpack_public_path__ + "static/media/ic_kcs_40.3188d6c7.svg";